<div *ngIf="!showLoading" class="container">
  <div id="affiliation-code">
    <img id="link-img" src="assets/images/link-1.png" alt="">
    <strong>
      <p>{{cfetLabels.cfet_affiliation_code.heading1}}</p>
      <h1>{{affiliateName}}</h1>
    </strong>
    <p id="desc1">{{cfetLabels.cfet_affiliation_code.desc1}}</p>
    <div class="btn-container">
      <!-- adding key down event -->
      <button type="button" id="btn-continue" (click)="continue($event)" (keyup)="continue($event)"
        class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
        {{cfetButtonLabels.button_labels.continue}}</button>
      <a (click)="cancel($event)" (keyup)="cancel($event)" tabindex="0" type="button" id="cancel_link"
        class="btn btn-secondary btn-clear cancel_link"><em aria-label=""></em>
        {{cfetButtonLabels.button_labels.cancel}}</a>
    </div>
  </div>
</div>
<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>